import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "person-contact-data-editor" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "is-primary-selector me-2" }
const _hoisted_4 = ["checked", "onChange"]
const _hoisted_5 = { class: "flex-fill" }
const _hoisted_6 = { class: "mt-2" }

import { PersonContactDataDto } from "@api/person-contact-data-dto";
import { useValidateProps } from "@/composables/fields";
import { getEntityTranslation } from "@/helpers";
import { PropType } from "vue";
import { computed, nextTick, onBeforeMount } from "vue";
import Validation from "./form/Validation.vue";
import { Field } from "@/types/interfaces/field";
import { dbEnums } from "@/types/enums/dbEnums";
import { ContactDataType } from "@api/contact-data-type";


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonContactDataEditor',
  props: {
	type: {
		type: String as PropType<ContactDataType>,
		required: true,
	},

	modelValue: {
		type: Object as PropType<PersonContactDataDto[]>,
		required: true,
	},

	field: {
		type: Object as PropType<Field>,
		required: true,
	},

	propertyPathBase: {
		type: String,
		required: true,
	},
},
  emits: ["update:modelValue", "validate"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emits = __emit;

const currentTypeDatas = computed(() => {
	return props.modelValue.filter((x) => x.type == props.type);
});

const dataCount = computed(() => {
	return props.modelValue.filter((x) => x.type == props.type).length;
});

onBeforeMount(() => {
	const isEmpty = dataCount.value == 0;
	if (isEmpty) {
		addNewData();
	}
});

const addNewData = (fromBtn = false) => {
	const mv = [...props.modelValue];

	const newData = {
		id: (mv.length + 1) * -1,
		type: props.type,
		data: "",
		isPrimary: dataCount.value == 0,
	} as PersonContactDataDto;

	mv.push(newData);

	emits("update:modelValue", mv);

	if (fromBtn) {
		nextTick(() => {
			document.getElementById("pcde-" + newData.id)?.focus();
		});
	}
};

const onInputBlur = (obj: PersonContactDataDto, propNames: string[]) => {
	removeIfEmpty(obj);
	nextTick(() => {
		/* const index = currentTypeDatas.value.indexOf(obj); */
		// emits("validate", generatePropertyPathForIndex(index));
		validateProps(propNames);
	});
};

const removeIfEmpty = (obj: PersonContactDataDto) => {
	if (obj.data.trim() == "" && dataCount.value > 1) {
		let mv = [...props.modelValue];
		mv = mv.filter((x) => x.id != obj.id);
		emits("update:modelValue", mv);
	}
};

const onChangePrimary = (obj: PersonContactDataDto) => {
	currentTypeDatas.value.forEach((d) => (d.isPrimary = false));
	obj.isPrimary = true;
};

const validateProps = useValidateProps();

const generatePropertyPathForIndex = (index: number) => {
	return `${props.propertyPathBase}.contactDatas[${index}].${props.type.toLowerCase()}`;
};

const fieldLabel = computed(() => {
	const label =
		(props.field && getEntityTranslation(props.field.translations, "name")) || "Missing label";
	return label;
});

return (_ctx: any,_cache: any) => {
  const _component_HakoBsIcon = _resolveComponent("HakoBsIcon")!
  const _component_HakoInput = _resolveComponent("HakoInput")!
  const _component_HakoTeleInput = _resolveComponent("HakoTeleInput")!
  const _component_HakoButton = _resolveComponent("HakoButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTypeDatas.value, (dataRow, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: dataRow.id!,
        class: _normalizeClass({ 'mt-1': index > 0 })
      }, [
        (dataRow.type == __props.type)
          ? (_openBlock(), _createBlock(Validation, {
              key: 0,
              fieldName: fieldLabel.value,
              propertyPaths: [generatePropertyPathForIndex(index)],
              matchCustomStateValue: __props.type.toLowerCase()
            }, {
              default: _withCtx(({ isInvalid, propertyPaths }) => [
                _renderSlot(_ctx.$slots, "default", { isInvalid: isInvalid }, () => [
                  _createElementVNode("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_HakoBsIcon, {
                        class: "me-1",
                        icon: dataRow.isPrimary ? 'star-fill' : 'star',
                        style: _normalizeStyle({ opacity: dataRow.isPrimary ? 1 : 0.25 })
                      }, null, 8, ["icon", "style"]),
                      _createElementVNode("input", {
                        type: "radio",
                        checked: dataRow.isPrimary,
                        onChange: ($event: any) => (onChangePrimary(dataRow))
                      }, null, 40, _hoisted_4)
                    ], 512), [
                      [_vShow, dataCount.value > 1]
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      (__props.type == _unref(dbEnums).ContactDataType.Email)
                        ? (_openBlock(), _createBlock(_component_HakoInput, {
                            key: 0,
                            type: "email",
                            modelValue: dataRow.data,
                            "onUpdate:modelValue": ($event: any) => ((dataRow.data) = $event),
                            id: 'pcde-' + dataRow.id,
                            onBlur: ($event: any) => (onInputBlur(dataRow, propertyPaths)),
                            isInvalid: isInvalid
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "onBlur", "isInvalid"]))
                        : (__props.type == _unref(dbEnums).ContactDataType.Phone)
                          ? (_openBlock(), _createBlock(_component_HakoTeleInput, {
                              key: 1,
                              modelValue: dataRow.data,
                              "onUpdate:modelValue": ($event: any) => ((dataRow.data) = $event),
                              id: 'pcde-' + dataRow.id,
                              onBlur: ($event: any) => (onInputBlur(dataRow, propertyPaths)),
                              isInvalid: isInvalid
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "onBlur", "isInvalid"]))
                          : (_openBlock(), _createBlock(_component_HakoInput, {
                              key: 2,
                              modelValue: dataRow.data,
                              "onUpdate:modelValue": ($event: any) => ((dataRow.data) = $event),
                              id: 'pcde-' + dataRow.id,
                              onBlur: ($event: any) => (onInputBlur(dataRow, propertyPaths)),
                              isInvalid: isInvalid
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "onBlur", "isInvalid"]))
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1032, ["fieldName", "propertyPaths", "matchCustomStateValue"]))
          : _createCommentVNode("", true)
      ], 2))
    }), 128)),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_HakoButton, {
        sm: "",
        theme: "success",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addNewData(true)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("generic.addNew")), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})